import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MzicSvgComponent } from '../mzic-svg/mzic-svg.component';
import { GenericConfirmDialogData } from './types';

@Component({
  selector: 'mzic-generic-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MzicSvgComponent],
  templateUrl: './generic-confirm-dialog.component.html',
  styleUrl: './generic-confirm-dialog.component.scss',
})
export class GenericConfirmDialogComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) description!: string;
  @Input() extra?: string;
  @Input() confirmButton = 'TRY AGAIN';
  @Input() cancelButton = 'CANCEL';
  @Input() theme: 'centralized' | 'default' = 'default';
  @Input() iconClass = 'red-500';
  @Input() iconSize = 'w64';
  @Input() iconUrl?: string;

  @Output() actionChange = new EventEmitter<'CONFIRM' | 'CLOSE'>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: GenericConfirmDialogData,
  ) {
    // Atribui os dados injetados às propriedades @Input
    this.title = data.title;
    this.description = data.description;
    this.extra = data.extra;

    if (data.theme) {
      this.theme = data.theme;
    }

    if (data.iconUrl) {
      this.iconUrl = data.iconUrl;
    }

    if (data.iconClass) {
      this.iconClass = data.iconClass;
    }

    if (data.iconSize) {
      this.iconSize = data.iconSize;
    }

    if (data.confirmButton) {
      this.confirmButton = data.confirmButton;
    }

    if (data.cancelButton) {
      this.cancelButton = data.cancelButton;
    }
  }

  handleEvent(event: string) {
    if (event === 'CLOSE') {
      this.closePopover();
    }

    if (event === 'TRY_AGAIN') {
      this.tryAgain();
    }
  }

  closePopover() {
    this.actionChange.next('CLOSE');
  }

  tryAgain() {
    this.actionChange.next('CONFIRM');
  }
}
